import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export function usePageView() {
  const location = useLocation();

  useEffect(() => {
    // Use a small delay to avoid interfering with auth session refresh on tab focus
    const timeout = setTimeout(async () => {
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        await supabase.from('page_views').insert({
          user_id: session?.user?.id || null,
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
        });
      } catch {
        // Silently fail — analytics should never break the app
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [location.pathname]);
}
